import React, { Component } from "react";
import { Col, Container, Row } from "react-bootstrap";
import ExternalClinicianSelect from "../../component/ExternalClinicianSelect";
import ExternalClinicSelect from "../../component/ExternalClinicSelect";

export default class ReferralCliniciansTab extends Component {

    render() {
        const { referral, onReferralChange, readOnly } = this.props;

        const selectStyles = {
            control: (base) => ({ ...base, minHeight: '26px', height: '26px', fontSize: '14px', padding: '0px' }),
            valueContainer: (base) => ({ ...base, height: '26px', padding: '0 8px' }),
            input: (base) => ({ ...base, margin: '0px', padding: '0px' }),
            indicatorsContainer: (base) => ({ ...base, height: '26px' }),
            option: (base) => ({ ...base, fontSize: '13px', padding: '6px 8px' }),
        };

        return (
            <Container>
                <Row>
                    <Col xs={10}>
                        <Field label="Referring Clinician Name" body={
                            <ExternalClinicianSelect
                                field="name"
                                type={referral.type}
                                value={referral.referringClinicianName}
                                disabled={readOnly}
                                styles={selectStyles}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                onTextChange={(text) => onReferralChange && onReferralChange(referral.id, 'referringClinicianName', text)}
                                onClinicianSelect={(clinician) => {
                                    if (!onReferralChange) return;
                                    onReferralChange(referral.id, 'referringClinicianName', clinician.name);
                                    onReferralChange(referral.id, 'referringClinicianLicenseNo', clinician.licenseNo);
                                    if (clinician.clinic) {
                                        onReferralChange(referral.id, 'referringClinicName', clinician.clinic.name);
                                        onReferralChange(referral.id, 'referringClinicId', clinician.clinic.clinicId);
                                    }
                                }}
                            />
                        }/>
                    </Col>
                </Row>
                <Row>
                    <Col xs={10}>
                        <Field label="Referring Clinician Licence" body={
                            <ExternalClinicianSelect
                                field="licenseNo"
                                type={referral.type}
                                value={referral.referringClinicianLicenseNo}
                                disabled={readOnly}
                                styles={selectStyles}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                onTextChange={(text) => onReferralChange && onReferralChange(referral.id, 'referringClinicianLicenseNo', text)}
                                onClinicianSelect={(clinician) => {
                                    if (!onReferralChange) return;
                                    onReferralChange(referral.id, 'referringClinicianName', clinician.name);
                                    onReferralChange(referral.id, 'referringClinicianLicenseNo', clinician.licenseNo);
                                    if (clinician.clinic) {
                                        onReferralChange(referral.id, 'referringClinicName', clinician.clinic.name);
                                        onReferralChange(referral.id, 'referringClinicId', clinician.clinic.clinicId);
                                    }
                                }}
                            />
                        }/>
                    </Col>
                </Row>
                <Row>
                    <Col xs={10}>
                        <Field label="Referring Clinic Name" body={
                            <ExternalClinicSelect
                                field="name"
                                type={referral.type}
                                value={referral.referringClinicName}
                                disabled={readOnly}
                                styles={selectStyles}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                onTextChange={(text) => onReferralChange && onReferralChange(referral.id, 'referringClinicName', text)}
                                onClinicSelect={(clinic) => {
                                    if (!onReferralChange) return;
                                    onReferralChange(referral.id, 'referringClinicName', clinic.name);
                                    onReferralChange(referral.id, 'referringClinicId', clinic.clinicId);
                                }}
                            />
                        }/>
                    </Col>
                </Row>
                <Row>
                    <Col xs={10}>
                        <Field label="Referring Clinic Id" body={
                            <ExternalClinicSelect
                                field="clinicId"
                                type={referral.type}
                                value={referral.referringClinicId}
                                disabled={readOnly}
                                styles={selectStyles}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                onTextChange={(text) => onReferralChange && onReferralChange(referral.id, 'referringClinicId', text)}
                                onClinicSelect={(clinic) => {
                                    if (!onReferralChange) return;
                                    onReferralChange(referral.id, 'referringClinicName', clinic.name);
                                    onReferralChange(referral.id, 'referringClinicId', clinic.clinicId);
                                }}
                            />
                        }/>
                    </Col>
                </Row>
            </Container>
        );
    }
}

class Field extends Component {
    render() {
        const { label, body } = this.props;
        return (
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4, gap: '10px' }}>
                <div style={{ minWidth: '160px', fontWeight: 'bold' }}>{label}:</div>
                <div style={{ flex: 1 }}>{body}</div>
            </div>
        );
    }
}
